import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

import './modal.css';

const Modal=({children, isOpen=false, className='', onClose, closeOnOverlayClick=true})=>{
  const rootElem=document.querySelector('#root');
  const scrollElem=document.scrollingElement;

  const [top,setTop]=useState(0);

  useEffect(()=>{
    if(isOpen) {

      const top=scrollElem.scrollTop;
      setTop(top);
      scrollElem.style.overflowY='hidden';
    }
    return () => {
      scrollElem.style.overflowY='';
    }
  },[isOpen]);

  if(!isOpen) {
    return false;
  }

  let finalClasses = 'modal-frame';
  if(className) {
    finalClasses+=' '+className;
  }

  let onOverLayClick=undefined;
  if(closeOnOverlayClick) {
    onOverLayClick=()=>onClose();
  }

  const stopProp=(e)=>{
    e.stopPropagation();
    return false;
  }

  const elem=(
    <div className="modal-base" onClick={onOverLayClick} style={{top:top}}>
      <div className={finalClasses} onClick={stopProp}>
        {children}
      </div>
    </div>
  )


  return ReactDOM.createPortal(elem,rootElem);
}

export default Modal;